import { InjectionToken } from '@angular/core';
import { IAppConfig } from '@models/app-config/app.config.model';
import { environment } from 'environments/environment';

export const APP_CONFIG_SERIVCE = new InjectionToken<IAppConfig>('app.config');
export const APP_CONFIG: IAppConfig = {
  apiEndpoint: environment.apiEndpoint,
};
